module.exports = __webpack_public_path__ + "static/media/whyus_calidad.5ebb4581.jpg";